import type { ApiResponse } from '@court-sync/shared';
import { apiGet } from './apiClient';

export interface UserOrganizationEntry {
  organizationId: string;
  slug: string;
  name: string;
  logoUrl: string | null;
  roles: Array<'guardian' | 'student' | 'member'>;
  academySlug: string | null;
  clubSlug: string | null;
  hasLessonsPortal: boolean;
  hasMembershipPortal: boolean;
}

export const userOrgService = {
  async getMyOrganizations(): Promise<ApiResponse<UserOrganizationEntry[]>> {
    return apiGet<UserOrganizationEntry[]>('/user/my-orgs');
  },
};
